import React, { useEffect } from 'react';
import './style/reset.css';
import { createGlobalStyle, ThemeProvider } from 'styled-components';
import { Provider } from 'react-redux';
import store from './store/config';
import Router from './router/Router';
import { PersistGate } from 'redux-persist/integration/react';
import { persistStore } from 'redux-persist';
let persistor = persistStore(store);

const theme = {
  black: '#000000',
  white: '#ffffff',
  gray50: '#f1f1f1',
  gray100: '#e2e2e2',
  gray200: '#c6c6c6',
  gray300: '#ababab',
  gray400: '#919191',
  gray500: '#777777',
  gray600: '#5e5e5e',
  gray700: '#474747',
  gray800: '#303030',
  gray900: '#1b1b1b',
  slate50: '#eff1f3',
  slate100: '#dfe3e7',
  slate200: '#c1c7d0',
  slate300: '#a3acba',
  slate400: '#8592a4',
  slate500: '#69788f',
  slate600: '#535f71',
  slate700: '#3e4755',
  slate800: '#2b313a',
  slate900: '#181c21',
  blue50: '#eaf1fb',
  blue100: '#d6e4f7',
  blue200: '#acc9ee',
  blue300: '#83aee6',
  blue400: '#5993dd',
  blue500: '#2e76d4',
  blue600: '#0058cb',
  blue700: '#004299',
  blue800: '#002e6a',
  blue900: '#001b3e',
  purple50: '#f1effd',
  purple100: '#e2e0fb',
  purple200: '#c6c1f6',
  purple300: '#aaa2f2',
  purple400: '#8e83ed',
  purple500: '#7164e9',
  purple600: '#5242e4',
  purple700: '#3e32ac',
  purple800: '#2b2277',
  purple900: '#191445',
  pink50: '#ffebff',
  pink100: '#fed6ff',
  pink200: '#fdaaff',
  pink300: '#fc75ff',
  pink400: '#d663d8',
  pink500: '#b052b2',
  pink600: '#8c418d',
  pink700: '#69316a',
  pink800: '#482249',
  pink900: '#2a132a',
  aqua50: '#dcf5ff',
  aqua100: '#b7eafe',
  aqua200: '#66d3fd',
  aqua300: '#03b7fc',
  aqua400: '#039bd5',
  aqua500: '#027faf',
  aqua600: '#02658b',
  aqua700: '#014c69',
  aqua800: '#013548',
  aqua900: '#011f2a',
  green50: '#def6ec',
  green100: '#bcedd9',
  green200: '#72daaf',
  green300: '#1dc37f',
  green400: '#19a56b',
  green500: '#148858',
  green600: '#106c46',
  green700: '#0c5135',
  green800: '#083824',
  green900: '#052015',
  red50: '#fcedf1',
  red100: '#f9dbe2',
  red200: '#f2b7c5',
  red300: '#eb91a7',
  red400: '#e46886',
  red500: '#db355d',
  red600: '#bc0c36',
  red700: '#8f0929',
  red800: '#65061d',
  red900: '#3d0412',
};

const GlobalStyle = createGlobalStyle`
  *, *::before, *::after {
    box-sizing: border-box;
  }

  body {
    font-family: "Helvetica Neue", "Helvetica", "Arial", sans-serif;
    line-height: 1.5;
    -webkit-user-select:none;
    -moz-user-select:none;
    -ms-user-select:none;
    user-select:none;
    letter-spacing: -0.04em;
    word-break: keep-all;
  }

  .typo-display {
    font-size: 4.125rem;
    line-height: 4.75rem;
    font-weight: 700;
    letter-spacing: -0.02em;
    margin: 0;
    padding: 0;
    word-break:keep-all !important;
  }
  h1, h2, h3, h4, h5, h6{
    color:black;
    font-family: "Helvetica Neue", "Helvetica", "Arial", sans-serif;
    word-break:keep-all !important;
  }
  h1 {
    font-size: 3.25rem;
    line-height: 3.75rem;
    font-weight: 700;
    letter-spacing: -0.02em;
  }
  
  h2 {
    font-size: 2.563rem;
    line-height: 3rem;
    font-weight: 600;
    letter-spacing: -0.02em;
  }
  
  h3 {
    font-size: 20px;
    line-height: 24px;
    font-weight: 500;
    letter-spacing: -0.02em;
  }
  
  h4 {
    font-size: 20px;
    line-height: 1.875rem;
    font-weight: 700;
    letter-spacing: -0.02em;
  }
  
  .typo-bold {
    font-weight: 700;
    font-size: 1.5rem;
    line-height: 1.75rem;
    margin: 0;
    padding: 0;
  }
  
  .typo-medium {
    font-weight: 500;
    font-size: 1.5rem;
    line-height: 1.75rem;
    margin: 0;
    padding: 0;
  }
  
  .sm-typo-bold {
    font-weight: 700;
    font-size: 1rem;
    line-height: 1.5rem;
    margin: 0;
    padding: 0;
  }
  
  .sm-typo-medium {
    font-weight: 500;
    font-size: 1rem;
    line-height: 1.5rem;
    margin: 0;
    padding: 0;
  }
  a{
    font-family: "Helvetica Neue", "Helvetica", "Arial", sans-serif;
    word-break:keep-all !important;
  }
  div, span {
    word-break: keep-all;
  }
  button{
    font-family: "Helvetica Neue", "Helvetica", "Arial", sans-serif;
    border:none;
  }
  .mobile-br{
    display:none;
    @media only screen and (max-width: 768px) {
      display:block;
    }
  }
  .mobile-dp-block{
    display:none;
    @media only screen and (max-width: 768px) {
      display:block;
    }
  }
  .mobile-dp-none{
    display:block;
    @media only screen and (max-width: 768px) {
      display:none;
    }
  }
  .lettering-loading {
    width: calc(100vw - 64px) !important;
    left: calc((100vw - 400px - 64px)*-1) !important;

    @media only screen and (max-width: 768px) {
      width: 100% !important;
      left: 0 !important;
      height: 100vh !important;
      top: calc((100vh - 272px)*-1) !important;
    }
  }
  footer{
    background:black;
  }
  .footer-text{
    height: 100%;
    display: flex;
    justify-content: center;
    padding: 65px;
    color:#69788F;
    font-weight: 500;
    font-size: 16px;
    line-height: 24px;
    text-align: center;
  }
`;

function App() {
  const { Kakao } = window;
  const Explain = useEffect(() => {
    Kakao.init('eb19d113a9d09000ebafeba89f9cbf02');
  }, []);
  useEffect(() => {
    window.addEventListener('beforeunload', function (e) {
      e.preventDefault();
    });
  }, []);
  return (
    <>
      <ThemeProvider theme={theme}>
        <Provider store={store}>
          <PersistGate loading={null} persistor={persistor}>
            <div className="App">
              <GlobalStyle />
              <Router />
            </div>
          </PersistGate>
        </Provider>
      </ThemeProvider>
    </>
  );
}

export default App;
